import { icons } from '@bonitour/font/selection.json'

export const iconHex = (iconName) =>
  icons
    .find((icon) => icon.properties.name === iconName)
    .properties.code.toString(16)
